import { GET_QUICKBOOK_TOKEN } from '../actions/types';
export default function (state = false, action) {
    switch (action.type) {
        case GET_QUICKBOOK_TOKEN:
            return action.payload;
        default:
            return state;
    }
}